/* Enhancements are local to the Residence sections. */
if (!customElements.get('skipstone-residence-video')) {
  customElements.define('skipstone-residence-video', class extends HTMLElement {
    async connectedCallback() {
      this.abort = new AbortController();
      await customElements.whenDefined('video-media');
      if (!this.isConnected || this.abort.signal.aborted) return;
      const media = this.querySelector('video-media');
      const button = this.querySelector('button');
      const fallback = this.querySelector('a');
      if (!media || !button) return;
      const signal = this.abort.signal;
      const update = () => {
        const playing = media.hasAttribute('playing');
        button.textContent = playing ? 'Pause video' : 'Play video';
        button.setAttribute('aria-label', playing ? 'Pause Residence video' : 'Play Residence video');
        if (playing) {
          media.dataset.hasPlayed = '';
          fallback.hidden = true;
          clearTimeout(this.fallbackTimer);
        }
      };
      media.addEventListener('media:play', update, {signal});
      media.addEventListener('media:pause', update, {signal});
      button.addEventListener('click', () => media.playing ? media.pause() : media.play(), {signal});
      button.hidden = false;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      motion.addEventListener('change', () => { if (motion.matches) media.pause(); }, {signal});
      if (this.dataset.autoplay === 'true' && !motion.matches) {
        media.setAttribute('autoplay', '');
        media.play();
        this.fallbackTimer = setTimeout(() => {
          if (!media.hasAttribute('data-has-played')) fallback.hidden = false;
        }, 15000);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      clearTimeout(this.fallbackTimer);
    }
  });
}
if (!customElements.get('skipstone-residence-booking')) {
  customElements.define('skipstone-residence-booking', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const arrival = this.querySelector('[name="checkInDate"]');
      const departure = this.querySelector('[name="checkOutDate"]');
      const form = this.querySelector('form');
      if (!arrival || !departure || !form) return;
      const parts = new Intl.DateTimeFormat('en-US', {timeZone:'America/Los_Angeles',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part = name => parts.find(p => p.type === name).value;
      arrival.min = `${part('year')}-${part('month')}-${part('day')}`;
      const nextDay = value => {
        const date = new Date(`${value}T12:00:00Z`);
        date.setUTCDate(date.getUTCDate() + 1);
        return date.toISOString().slice(0,10);
      };
      const validate = () => {
        departure.min = nextDay(arrival.value || arrival.min);
        departure.setCustomValidity(departure.value && departure.value < departure.min ? 'Please choose a departure after your arrival.' : '');
      };
      arrival.addEventListener('change', validate, {signal:this.abort.signal});
      departure.addEventListener('change', validate, {signal:this.abort.signal});
      form.addEventListener('submit', event => {
        validate();
        if (!form.reportValidity()) event.preventDefault();
      }, {signal:this.abort.signal});
      validate();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
